import { TFormData } from 'components/contactForm/contactForm.types';
import styles from 'components/contactForm/submitButton/submitButton.module.css';
import { useTranslation } from 'react-i18next';

export interface ISubmitButtonProps {
    step: number;
    values: TFormData;
    setStep: (_val: number) => void;
    isSubmitting: boolean;
}
export const SubmitButton = ({
    step,
    values,
    setStep,
    isSubmitting,
}: ISubmitButtonProps) => {
    const { t } = useTranslation();
    const handleNextStep = (values: TFormData) => {
        if (step === 1 && !!values.eventType && !!values.name) {
            setStep(2);
        } else if (step === 2 && !!values.date) {
            setStep(3);
        }
    };
    return (
        <>
            {step < 3 ? (
                <button
                    type="button"
                    className={styles.calculateButton}
                    disabled={
                        (step === 1 && !values.eventType) ||
                        (step === 2 && !values.date)
                    }
                    onClick={() => handleNextStep(values)}
                >
                    {t('contactForm.next')}
                </button>
            ) : (
                <button
                    type="submit"
                    className={styles.calculateButton}
                    disabled={isSubmitting}
                >
                    {t('contactForm.calculate')}
                </button>
            )}
        </>
    );
};
